// extracted by mini-css-extract-plugin
module.exports = {"parallaxBody":"parallax-module--parallax-body--5uaku","parallaxImage":"parallax-module--parallax-image--3Pe0l","isRoot":"parallax-module--is-root--1c0RZ"};